export default __webpack_public_path__ + "static/media/StaticPage2.15fde704.txt";